// extracted by mini-css-extract-plugin
export default {"button":"Apps_button__uVQjp","openButton":"Apps_openButton__Hoez9","buttonIcon":"Apps_buttonIcon__Jh3xa"};